module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-cba8a2d7d36c4565ac7b4e175a8fc907.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }